import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListItem.css';
import cx from 'classnames';

// Redux action
import { ManagePublishStatus } from '../../../actions/Listing/ManagePublishStatus';

// Locale
import messages from '../../../locale/messages';

const PublishOption = ({ listId, isPublished }) => {

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const handleChange = (event) => {
        let action = event.target.value;
        dispatch(ManagePublishStatus(listId, action));
    }

    return (
        <span className="publishArrow">
            <select className={cx(s.formSelect, s.formSelectNew)} value={isPublished ? 'publish' : 'unPublish'} onChange={handleChange}>
                <option value="publish">{formatMessage(messages.listed)}</option>
                <option value="unPublish">{formatMessage(messages.unListed)}</option>
            </select>
        </span>
    )
}


PublishOption.propTypes = {
    listId: PropTypes.number.isRequired,
    isPublished: PropTypes.bool.isRequired
};

PublishOption.defaultProps = {
    isPublished: false
};

export default withStyles(s)(PublishOption);